module.exports = __webpack_public_path__ + "img/search.0d05ad1c.svg";